import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { usePageViews } from '../../utils/analytics';

const Error = () => {
  usePageViews();
  return (
    <div style={{ textAlign: 'center' }}>
      <Typography variant='subtitle1' style={{ marginBottom: 20 }}>
        An error occurred that prevented this page from being loaded.
        <br />
        Try reloading the page or logging out and back in.
      </Typography>
      <Button variant='outlined' color='primary' component={Link} to='/logout'>
        Logout
      </Button>
    </div>
  );
};

export default Error;
